import type { SchemaViewerFieldLabelProps } from "./schema-viewer-field-label.type";

import { htmlSanitizer, RichTextEditor } from "@/ui/rich-text-editor";

export const SchemaViewerFieldLabel = ({
  schema,
}: SchemaViewerFieldLabelProps) => {
  return (
    <RichTextEditor
      theme="bubble"
      value={htmlSanitizer(schema.label)}
      readOnly
    />
  );
};
